// Справочник способов гашения долга: название, подпись поля и пояснение.
//
// Рядом с `debt-types` и по той же причине: справочник понадобился двум разделам — форме
// заведения долга в карточке человека и карточке долга в реестре «Расчёта».
//
// Всё, что здесь есть, приходит с сервера, включая подписи полей. Это не перестраховка:
// единица измерения значения графика зависит от способа (копейки, месяцы, проценты), и экран,
// который решает подпись сам, однажды спросит рубли там, где нужны месяцы. Человек впишет
// 3 000 вместо 3, и долг будет гаситься по рублю в расчёт двести пятьдесят лет.

import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';

import type { DebtScheduleTypeOut } from '@/shared/api/endpoints/losses';
import { fetchDebtScheduleTypes } from '@/shared/api/endpoints/losses';
import type { ListResponse } from '@/shared/api/types';
import type { ApiError } from '@/shared/errors/api-error';

export function useDebtScheduleTypes(): UseQueryResult<
  ListResponse<DebtScheduleTypeOut>,
  ApiError
> {
  return useQuery<ListResponse<DebtScheduleTypeOut>, ApiError>({
    queryKey: ['dictionaries', 'debt-schedule-types'],
    queryFn: () => fetchDebtScheduleTypes(),
    // Справочник из контракта: он меняется вместе с выкладкой, а не в течение смены.
    staleTime: 10 * 60 * 1000,
  });
}
